import { Document, Image, Page, Text, View } from '@react-pdf/renderer';
import React from 'react'
import { css } from './css';
import { images } from '../../../app/Paths';

export const OrderPurcharse = ({ detailRequest, detailItems }) => {

  let f = new Date(); let dia = f.getDate(); let mes = f.getMonth() + 1; if (dia < 10) dia = "0" + dia; if (mes < 10) mes = "0" + mes;
  let dateRegister = dia + "-" + mes + "-" + f.getFullYear();
  let fechahora = new Date(); let hora = fechahora.getHours(); let minuto = fechahora.getMinutes(); let segundo = fechahora.getSeconds();
  if (minuto < 10) minuto = "0" + minuto; if (segundo < 10) segundo = "0" + segundo;
  let hourRegister = `${hora}:${minuto}:${segundo}`;

  const purcharseOrder =detailRequest;
  const purchaseOrderDetails = [...detailItems];

  return (
    <Document title='Reporte de Orden de compra de productos' producer='HDL Technology' pdfVersion='1.0'>
      <Page size="LETTER" orientation='portrait'>

        <View style={css.row}>
          <View style={[css.px_4, { marginTop: 20 }]}>
            <Image src={images.logo} style={css.logo} />
          </View>
          <View style={[css.px_3, { marginTop: 20 }]}>
            <Text style={[css.h1, css.fw_bold]}>HARDWARE DIAGNOSTIC LAB OF TECHNOLOGY</Text>
            <Text style={[css.h6, css.px_8,]}>Reporte de Orden de Compra de Productos ({purcharseOrder?.NUMBER})</Text>
          </View>

          <View style={[css.px_3, { marginTop: 20 }]}>
             <Text style={[css.tText]}>Cap. {purcharseOrder?.USERNAME_REGISTER}</Text>
            <Text style={[css.tText]}>Dia:    {purcharseOrder?.DATEREGISTER}</Text>
            <Text style={[css.tText]}>Hora: {purcharseOrder?.HOURREGISTER} hrs.</Text>
            <Text style={[css.tText]}>Rev.  {purcharseOrder?.USERNAME_REVIEW}</Text>
            <Text style={[css.tText]}>Dia:  {purcharseOrder?.DATEREVIEWER}</Text>
            <Text style={[css.tText]}>Hora:  {purcharseOrder?.HOURREVIEWER} hrs.</Text>
          </View>
        </View>

        <View style={[css.row, { marginTop: 10 }]}>
          <View style={[css.px_4, css.text_center]}>
            <Text style={[ css.py_1, css.h6, css.fwBold]}>FOLIO: {purcharseOrder?.NUMBER}</Text>
            <Text style={[ css.py_1, css.h6, css.fwBold]}>Estado: {purcharseOrder?.STATUSDESC}</Text>
            {/* <Text style={[css.px_1, css.py_1, css.h6, css.fwBold]}>Comentarios: {purcharseOrder?.notes}</Text> */}
          </View>
        </View>


        <Text style={[css.px_4, css.py_1, css.h6, css.fwBold, { marginTop: 5 }]}>Listado de Productos solicitados </Text>
        <View style={[css.row, css.px_4, css.py_4, { marginTop: 5 }]}>
          <View style={css.table}>
            <View style={css.tableRowHeader}>
              <Text style={[css.tableCellHeader, css.lastCell, { flex: 0.5 }]}>SKU</Text>
              <Text style={[css.tableCellHeader, css.lastCell, css.text_start, { flex: 1 }]}>CATEGORIA</Text>
              <Text style={[css.tableCellHeader, css.lastCell, css.text_center]}>MARCA</Text>
              <Text style={[css.tableCellHeader, css.lastCell, css.text_justify, { flex: 2 }]}>PRODUCTO</Text>
              <Text style={[css.tableCellHeader, css.lastCell, css.text_center]}>PROVEEDOR</Text>
              <Text style={[css.tableCellHeader, css.lastCell, css.text_center]}>REQUERIDO</Text>
              <Text style={[css.tableCellHeader, css.lastCell, css.text_center]}>APROBADO</Text>
            </View>

            {purchaseOrderDetails?.map((item, index) => (
              <View key={index} style={css.tableRow}>
                <Text style={[css.tableCellHeader, css.lastCell, { flex: 0.5 }]}>{item.SKU}</Text>
                <Text style={[css.tableCell, css.lastCell, css.text_start, { flex: 1 }]}>{item.NAMECATEGORY}</Text>
                <Text style={[css.tableCell, css.lastCell, css.text_center]}>{item.NAMEBRAND}</Text>
                <Text style={[css.tableCell, css.lastCell, css.text_justify, { flex: 2 }]}>{item.NAME_PRODUCT}: {item.DESCRIPTION_PRODUCT} </Text>
                <Text style={[css.tableCell, css.lastCell, css.text_center]}>{item.NAMESUPPLIER}</Text>
                <Text style={[css.tableCell, css.lastCell, css.text_center]}>{item.QUANTITY}</Text>
                <Text style={[css.tableCell, css.lastCell, css.text_center]}>{item.QUANTITY_APPROVED}</Text>
              </View>
            ))}
          </View>
        </View>
      </Page>
    </Document>
  )
}
